import React from "react";
import { IMaskInput } from "react-imask";

type InputMaskProps = {
  value: any;
  onChange: (val: any) => void;
  placeholder?: any;
  regexMask?: RegExp;
  maskString?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  className?: string;
  onBlur?: (ev: { target: { value: string } }) => void;
  unmask?: any;
};

export default function InputMaskComponent({
  value,
  onChange,
  placeholder,
  regexMask,
  maskString,
  inputRef,
  className,
  onBlur,
  unmask
}: InputMaskProps) {

    
//MARK: convertRegexToMask V1
//   const convertRegexToMask = (regex: RegExp) => {
//     const str = regex.source;
//     const mask: (string | RegExp)[] = [];

//     for (let i = 0; i < str.length; i++) {
//       const c = str[i];
//       if (c === "\\") continue;
//       if (c === "d") mask.push(/\d/);
//       else if (c === "w") mask.push(/\w/);
//       else if (c === "D") mask.push(/\D/);
//       else mask.push(c);
//     }
//     return mask;
//   };

//MARK: convertRegexToMask V2
//   function convertRegexToMask(regex: RegExp): (string | RegExp)[] {
//   const src = regex.source;

//   const mask: (string | RegExp)[] = [];
//   let i = 0;

//   while (i < src.length) {
//     // sequência fixa "NL", "B", etc
//     if (/[A-Za-z]/.test(src[i]) && src[i - 1] !== "\\") {
//       mask.push(src[i]);
//       i++;
//       continue;
//     }

//     // bloco: [0-9]{9}
//     const numberBlock = src.slice(i).match(/^\[0-9\]\{(\d+)\}/);
//     if (numberBlock) {
//       const count = Number(numberBlock[1]);
//       for (let j = 0; j < count; j++) mask.push(/\d/);
//       i += numberBlock[0].length;
//       continue;
//     }

//     // literal ignorado
//     i++;
//   }

//   return mask;
// }

//MARK: convertRegexToMask V3
// function convertRegexToMask(regex: RegExp): (string | RegExp)[] {
//   const src = regex.source;
//   const mask: (string | RegExp)[] = [];

//   let i = 0;

//   while (i < src.length) {

//     // bloco do tipo: [0-9]{9}
//     const numberBlock = src.slice(i).match(/^\[0-9\]\{(\d+)\}/);
//     if (numberBlock) {
//       const count = Number(numberBlock[1]);
//       for (let j = 0; j < count; j++) mask.push(/\d/);
//       i += numberBlock[0].length;
//       continue;
//     }

//     // bloco literal: [B]
//     const literalBlock = src.slice(i).match(/^\[([A-Za-z])\]/);
//     if (literalBlock) {
//       mask.push(literalBlock[1]); // "B"
//       i += literalBlock[0].length;
//       continue;
//     }

//     // letras fixas (N, L)
//     if (/[A-Za-z]/.test(src[i]) && src[i - 1] !== "\\") {
//       mask.push(src[i]);
//       i++;
//       continue;
//     }

//     // ignora caracteres especiais fora da máscara
//     i++;
//   }

//   return mask;
// }

//MARK: convertRegexToMask V4
function regexToIMaskString(regex: RegExp): string {
  const src = regex.source;

  let out = "";

  let i = 0;
  while (i < src.length) {

    // NL literais
    if (/[A-Za-z]/.test(src[i]) && src[i - 1] !== "\\") {
      out += src[i];
      i++;
      continue;
    }

    // [0-9]{n}
    const numberBlock = src.slice(i).match(/^\[0-9\]\{(\d+)\}/);
    if (numberBlock) {
      const count = Number(numberBlock[1]);
      out += "0".repeat(count);
      i += numberBlock[0].length;
      continue;
    }

    // [B]
    const literalBlock = src.slice(i).match(/^\[([A-Za-z])\]/);
    if (literalBlock) {
      out += literalBlock[1];
      i += literalBlock[0].length;
      continue;
    }

    i++;
  }

  return out;
}

  const mask = regexMask
    ? regexToIMaskString(regexMask)
    : maskString ?? "";


  // Para compatibilidade com React 19 + IMask
  const maskForIMask: any = mask;

  function onBlurHandler() {
    if (!onBlur) return;

    const fakeEvent = {
      target: {
        value: String(value ?? ""),
      },
    };

    onBlur(fakeEvent);
  }

  return (
    <IMaskInput
      className={className}
      mask={maskForIMask} 
      value={value}
      unmask={unmask || false}
      onAccept={(val: string) => {
        onChange(val);
      }}
      placeholder={placeholder}
      inputRef={inputRef}
      onBlur={onBlurHandler}
    />
  );
}
